import React, { useEffect, useState } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import {
    Container,
    Header,
    Content,
    Footer,
    Sidebar as Side } from 'rsuite';
import {
    Label,
    Button,
    Popup } from 'semantic-ui-react'
import { api } from '../../../services/api';
import { isAdmin } from "../../../services/auth";
import moment from 'moment';

import Sidebar from '../../../components/Sidebar';
import Navbarr from '../../../components/Navbar';
import CardTable from '../../../components/CardTable';

import './styles.css';

export default function PromoterList () {
    const history = useHistory();
    const [userStates, setUserStates] = useState({
        isLoadingData: true,
        lastUpdate: "",
        reloadControl: false,
    });

    const [tableData, setTableData] = useState({
        columns: [
            {
                label: 'Nome',
                field: 'nome',
                sort: 'asc',
                width: 400
            },
            {
                label: 'Email',
                field: 'email',
                sort: 'asc',
                width: 400
            },
            {
                label: 'Papel',
                field: 'roleT',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Status',
                field: 'statusT',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Ações',
                field: 'acao',
                sort: 'asc',
                width: 100
            }


        ],
        rows: [],
    });

    const updateUsersData = () => {
        setUserStates( state => ({
            ...state,
            reloadControl: !state['reloadControl'],
        }));
    }

    useEffect(() => {
        const goToUserEditScreen = (e, user, index) => {
            e.preventDefault();
            history.push(`/users/${index}`, {userEmail: user['email']});
        }

        const changeUserForTable = (user, index) => {
            //user['lojasQtd'] = user['lojas'].length;
            //user['rotasQtd'] = user['rotas'].length;
            user['statusT'] = user['status'] === 'ATIVO'
                    ? <Label color='green' size='mini'>{user['status']}</Label>
                    : <Label color='red' size='mini'>{user['status']}</Label>
            user['roleT'] = user['role'] === 'ROLE_ADMIN' ? 'Administrador' : 'Promotor';
        user['acao'] = <Popup content='Visualizar'
            trigger={
                <Button basic size='mini' icon='eye' onClick={(e) => goToUserEditScreen(e, user, index)} />
            } />

            return user;
        }

        async function fetchUsers() {
            setUserStates( state => ({
                ...state,
                isLoadingData: true
            }));
            try {
                let data = await api.getUsers();
                let promoters = data.filter(
                    item => item['role'] === "ROLE_USUARIO"
                )
                promoters.forEach((element, index) => { changeUserForTable(element, index)});

                setTableData( state => ({
                  ...state,
                  rows: promoters
                }));

                setUserStates( state => ({
                    ...state,
                    isLoadingData: false,
                    lastUpdate: moment().format('LT')
                }));
            } catch (err) {
                console.error("Falha ao obter usuários: ", err);
            }
        }

        if (isAdmin()) fetchUsers();
    },[userStates.reloadControl, history]);

    if (isAdmin()) {
        return (
            <Container className="u-content">
                <Side style={{flex: '0 0 auto', width: 'auto'}}>
                    <Sidebar page={"promoterlist"}></Sidebar>
                </Side>
                <Container>
                    <Header>
                        <Navbarr></Navbarr>
                    </Header>
                    <Content style={{ backgroundColor: '#FAFAFA', padding: '5px'}}>
                        <CardTable
                            type={'promoter'}
                            data={tableData}
                            tableTitle={"Usuários Cadastrados"}
                            elementsName={"Usuários"}
                            isLoadingData={userStates['isLoadingData']}
                            lastUpdate={userStates['lastUpdate']}
                            updateData={updateUsersData}
                            />
                    </Content>
                    <Footer></Footer>
                </Container>
            </Container>
        )
    } else {
        return ( <Redirect to="/dashboard" /> );
    }
}
